import {
  EventTrackEnhancer,
  type Datalayer,
  type DatalayerInputEvent,
} from '@analytics/models';
import { Injectable } from '@angular/core';

@Injectable()
export class ABTestEnhancer extends EventTrackEnhancer {
  enhance(event: DatalayerInputEvent, datalayer: Datalayer) {
    const tests = datalayer.getVariable('activeABTests');
    if (tests) {
      return {
        ...event,
        info: { ...event.info, activeABTests: tests },
      };
    }
    return event;
  }
}
